import { AppBar, Toolbar, Typography, Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AFNdarkbg from "../assets/AFNdarkbg.png";
import SRUCWhite from "../assets/SRUCWhite.png";
import resas from "../assets/resas.png";
import ScotGov from "../assets/ScotGov.png";

const NavBar = () => {
  const navigate = useNavigate();

  return (
    <AppBar
      position="static" 
      elevation={1}
      sx={{
        backgroundColor: theme => theme.custom.appBar.main,
        color: theme => theme.custom.appBar.contrastText,
      }}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box>
          <Button color="secondary" variant="outlined" onClick={() => navigate('/')} sx={{ mr: 2}}>
            Home
          </Button>
        </Box>
        <Typography variant="h6" component="div">
          Prototype Slurry Emissions Forecast
        </Typography>
          <Box
            sx={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                columnGap: 0,       // smaller spacing between columns
                rowGap: 1,        // tighter spacing between rows
                alignItems: "center",
                justifyItems: "left",   
                py: 1 
              }}

          >
            <img src={SRUCWhite} alt="SRUCWhite" style={{ height: 30 }} />
            <img src={ScotGov} alt="SG" style={{ height: 25 }} />
            <img src={AFNdarkbg} alt="AFNdarkbg"  style={{ height: 35 }} />
            <img src={resas} alt="RESAS" style={{ height: 35 }} />
          </Box>
      </Toolbar>
    </AppBar>
  );
}

export default NavBar;
